export default __webpack_public_path__ + "static/media/sticker-y.b5eff0e6.png";